import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, timeout: { type: Number, default: 30000 } }
  static targets = ["progress"]

  connect() {
    this.startTimer()
  }

  disconnect() {
    this.clearTimer()
  }

  undo() {
    if (this.undoing) return
    this.undoing = true
    this.clearTimer()

    const token = document.querySelector('meta[name="csrf-token"]')?.content
    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": token,
        "Accept": "text/vnd.turbo-stream.html, text/html"
      }
    }).then(response => {
      if (response.redirected) {
        this.element.remove()
        window.Turbo.visit(response.url)
      } else if (response.ok) {
        this.element.remove()
        window.location.reload()
      } else {
        this.undoing = false
        this.element.querySelector("[data-action]").textContent = "Erreur"
      }
    }).catch(() => {
      this.undoing = false
      this.element.querySelector("[data-action]").textContent = "Erreur"
    })
  }

  dismiss() {
    this.clearTimer()
    this.element.remove()
  }

  startTimer() {
    if (this.hasProgressTarget) {
      this.progressTarget.style.transition = `width ${this.timeoutValue}ms linear`
      requestAnimationFrame(() => { this.progressTarget.style.width = "0%" })
    }
    this.timer = setTimeout(() => this.dismiss(), this.timeoutValue)
  }

  clearTimer() {
    if (this.timer) clearTimeout(this.timer)
  }
}
